<template>
  <div :data-automation="`whatsnew-release-`+whatsNewItem.release">
    <h4
      class="dateHeading"
      data-automation="whatsnew-release-header"
    >
      Release {{ whatsNewItem.release }}
    </h4>
    <h3 data-automation="whatsnew-header">
      {{ whatsNewItem.header }}
    </h3>
    <!-- eslint-disable vue/no-v-html -->
    <p>
      <span
        data-automation="whatsnew-description"
        v-html="whatsNewItem.description"
      />
    </p>
    <p>
      <span
        class="howTo"
        data-automation="whatsnew-howto-header"
      >how to</span><br>
      <span
        data-automation="whatsnew-howto-desc"
        v-html="whatsNewItem.howTo"
      />
    </p>
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>
<script>

export default {
  name: 'WhatsNewItem',
  components: {
  },
  props: {
    whatsNewItem: {
      type: Object,
      required: true,
    },
  },
}

</script>

<style scoped>

.howTo {
  padding: 4px 6px;
  font-size: 9px;
  letter-spacing: 1px;
  background-color: #e3eef8;
  border-radius: 3px;
  text-transform: uppercase;
}

</style>
